<div class="modal-backdrop" (click)="closeModal()">
  <div class="activation-edit-modal" role="dialog" aria-modal="true" (click)="$event.stopPropagation()">

    <header class="modal-header">
      <div>
        <h3>{{ 'destinations.activation.editTitle' | translate: { name: target?.destinationName ?? '' } }}</h3>
        @if (audienceName) {
          <p>{{ audienceName }}</p>
        }
      </div>
      <button type="button" class="ghost-btn compact" aria-label="Close" (click)="closeModal()">×</button>
    </header>

    <section class="modal-body">

      @if (isLoading) {
        <div class="form-loading">
          {{ 'destinations.activation.loadingDestinations' | translate }}
        </div>
      } @else {
        <form class="activation-form" [formGroup]="channelDataForm" (ngSubmit)="onSubmit()">

          @switch (activationParamsType) {

            @case ('Pubmatic') {
              <label class="form-field">
                <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                <input type="text" formControlName="ExternalSegmentID">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.pubmaticAudienceId' | translate }}</span>
                <input type="text" formControlName="PubmaticAudienceID">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                <input type="text" formControlName="Name">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.description' | translate }}</span>
                <input type="text" formControlName="Description">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.country' | translate }}</span>
                <app-custom-select formControlName="Country"
                                   [options]="countryOptions"
                                   [searchable]="true">
                </app-custom-select>
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.price' | translate }}</span>
                <input type="text" formControlName="Price">
              </label>
            }

            @case ('TheTradeDesk') {
              <label class="form-field">
                <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                <input type="text" formControlName="CustomAudienceName">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.description' | translate }}</span>
                <input type="text" formControlName="CustomAudienceDesc">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                <input type="text" formControlName="ExternalSegmentID">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.externalSegmentParentId' | translate }}</span>
                <input type="text" formControlName="ExternalSegmentParentID">
              </label>
              <div class="form-row">
                <label class="form-field">
                  <span>{{ 'destinations.fields.cpmRateAmount' | translate }}</span>
                  <input type="number" formControlName="CPMRateAmount" step="0.01">
                </label>
                <label class="form-field">
                  <span>{{ 'destinations.fields.cpmCurrency' | translate }}</span>
                  <app-custom-select formControlName="CPMRateCurrencyCode"
                                     [options]="ttdCurrencyOptions">
                  </app-custom-select>
                </label>
              </div>
              <label class="form-field">
                <span>{{ 'destinations.fields.percentOfMediaCost' | translate }}</span>
                <input type="number" formControlName="PercentOfMediaCostRate" step="0.01">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.rateLevel' | translate }}</span>
                <app-custom-select formControlName="RateLevel"
                                   [options]="rateLevelOptions">
                </app-custom-select>
              </label>
              @if (rateLevelValue === 'Partner') {
                <label class="form-field">
                  <span>{{ 'destinations.fields.partnerId' | translate }}</span>
                  <input type="text" formControlName="PartnerId">
                </label>
              }
              @if (rateLevelValue === 'Advertiser') {
                <label class="form-field">
                  <span>{{ 'destinations.fields.advertiserId' | translate }}</span>
                  <input type="text" formControlName="AdvertiserId">
                </label>
              }
              <label class="form-field form-field--checkbox">
                <input type="checkbox" formControlName="Buyable">
                <span>{{ 'destinations.fields.buyable' | translate }}</span>
              </label>
            }

            @case ('TheTradeDesk1pd') {
              <label class="form-field">
                <span>{{ 'destinations.fields.audienceName' | translate }}</span>
                <input type="text" formControlName="CustomAudienceName">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.region' | translate }}</span>
                <app-custom-select formControlName="Region"
                                   [options]="ttd1pdRegionOptions">
                </app-custom-select>
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.segmentType' | translate }}</span>
                <app-custom-select formControlName="SegmentType"
                                   [options]="ttd1pdSegmentTypeOptions">
                </app-custom-select>
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.mergeMode' | translate }}</span>
                <app-custom-select formControlName="MergeMode"
                                   [options]="ttd1pdMergeModeOptions">
                </app-custom-select>
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.advertiserId' | translate }}</span>
                <input type="text" formControlName="AdvertiserID">
              </label>
            }

            @case ('TheTradeDeskOfflineConversion') {
              <label class="form-field">
                <span>{{ 'destinations.fields.trackingTagName' | translate }}</span>
                <input type="text" formControlName="TrackingTagName">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                <input type="text" formControlName="ExternalSegmentID">
              </label>
            }

            @case ('AudienceRealtime') {
              <label class="form-field">
                <span>{{ 'destinations.fields.externalAudienceName' | translate }}</span>
                <input type="text" formControlName="ExternalAudienceName">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.description' | translate }}</span>
                <input type="text" formControlName="Description">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.ownerId' | translate }}</span>
                <input type="text" formControlName="OwnerID">
              </label>
              <label class="form-field">
                <span>{{ 'destinations.fields.ttl' | translate }}</span>
                <input type="number" formControlName="TTL" min="1">
              </label>
            }

            @case ('Zeotap') {
              <label class="form-field">
                <span>{{ 'destinations.fields.zeotapAccountType' | translate }}</span>
                <app-custom-select formControlName="AccountType"
                                   [options]="zeotapAccountTypeOptions">
                </app-custom-select>
              </label>
              @if (zeotapAccountTypeValue === 'Marketplace') {
                <label class="form-field">
                  <span>{{ 'destinations.fields.zeotapSegmentId' | translate }}</span>
                  <input type="text" formControlName="ExternalSegmentID">
                </label>
              }
              @if (zeotapAccountTypeValue === 'Advertiser') {
                <label class="form-field">
                  <span>{{ 'destinations.fields.segmentName' | translate }}</span>
                  <input type="text" formControlName="SegmentName">
                </label>
                <label class="form-field">
                  <span>{{ 'destinations.fields.description' | translate }}</span>
                  <input type="text" formControlName="Description">
                </label>
                <label class="form-field">
                  <span>{{ 'destinations.fields.cpmPrice' | translate }}</span>
                  <input type="number" formControlName="Price" step="0.01" min="0">
                </label>
                <label class="form-field">
                  <span>{{ 'destinations.fields.countries' | translate }}</span>
                  <app-custom-select formControlName="Countries"
                                     [options]="countryOptions"
                                     [multiple]="true"
                                     [searchable]="true">
                  </app-custom-select>
                </label>
                <label class="form-field">
                  <span>{{ 'destinations.fields.zeotapDestinationId' | translate }}</span>
                  <input type="text" formControlName="ZeotapDestinationID">
                </label>
              }
            }

            @default {
              <label class="form-field">
                <span>{{ 'destinations.fields.externalSegmentId' | translate }}</span>
                <input type="text" formControlName="ExternalSegmentID">
              </label>
            }

          }

          @if (hasGlobalDataAccess) {
            <label class="form-field form-field--checkbox">
              <input type="checkbox" formControlName="ExcludeControlGroup">
              <span>{{ 'destinations.fields.excludeControlGroup' | translate }}</span>
            </label>
          }

          @if (!hasEditableFields) {
            <p class="no-editable-fields">{{ 'destinations.activation.noEditableFields' | translate }}</p>
          }

          <div class="form-actions">
            <button type="button" class="ghost-btn" (click)="closeModal()">
              {{ 'audiences.actions.cancel' | translate }}
            </button>
            <button type="submit" class="primary-btn"
                    [disabled]="channelDataForm.invalid || isSubmitting || !hasEditableFields">
              {{ isSubmitting ? ('common.processing' | translate) : ('destinations.activation.saveButton' | translate) }}
            </button>
          </div>

        </form>
      }

    </section>

  </div>
</div>
